// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__CTWB5","child1":"style_child1__RsScB","child2":"style_child2__CFoQI"};